import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

export default class extends React.Component {
    static propTypes = {
		bio: PropTypes.string,
		ID: PropTypes.number.isRequired,
		first: PropTypes.string.isRequired,
		last: PropTypes.string.isRequired,
		link: PropTypes.string.isRequired,
		profile_picture: PropTypes.string.isRequired
	};

    render() {
		return (
			<div className="row author">
				<div className="col-sm-2 col-xs-4">
					<Link to={this.props.link}>
						<div style={{backgroundImage: 'url(' + this.props.profile_picture + ')'}} className="profile-image" />
					</Link>
				</div>
				<div className="col-sm-10 col-xs-8">
					<Link to={this.props.link}>
						<h4 className="mtop5-xs author__name">{this.props.first + ' ' + this.props.last}</h4>
					</Link>
						<p className="">{this.props.bio}</p>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Article/components/User.js